import { Pipe, PipeTransform } from "@angular/core";
import { ConfigurationService } from "../services/configuration.service";

@Pipe({
  name: "textModifier",
  pure: false
})
export class TextModifierPipe implements PipeTransform {
  constructor(private configSvc: ConfigurationService) {}

  transform(value: string, id: string, config: any) {    
        if (id !== "COMMUTE") return value;
        if (config.flattenedSettings.showCabs && config.flattenedSettings.showParking) {
          value = value.includes("Add") ? "Add Cab/Parking" : "Cab/Parking";
        } else if (config.flattenedSettings.showCabs) {
          value = value.includes("Add") ? "Add Cab" : "Cab";
        } else if (config.flattenedSettings.showParking) {
          value = value.includes("Add") ? "Add Parking" : "Parking";
        }
        return value;
  }
}
